import { RefreshButton, SelectColumnsButton, TopToolbar } from 'ra-ui-materialui';
import { FiberNew } from '@mui/icons-material';
import { Button } from 'react-admin';
import { ROLE_BIG_CREATE_INTERVENTION, ROLE_BIG_UPDATE_INTERVENTION_STATUS } from '@/utils/CONST';
import MultiSelectionButton from '@/components/common/multi-selection-button/multi-selection-button';
import { usePermissions } from 'react-admin';

interface Props {
    multiSelectionState: boolean;
    setMultiSelectionState: any;
    onOpenCreateDialog: () => void;
}

const InterventionsListActions = ({ multiSelectionState, setMultiSelectionState, onOpenCreateDialog }: Props) => {
    const { permissions } = usePermissions();

    return (
        <TopToolbar sx={{ display: 'flex', alignItems: 'center' }}>
            {permissions?.includes(ROLE_BIG_CREATE_INTERVENTION) && (
                <Button onClick={onOpenCreateDialog} label={'intervention.create'}>
                    <FiberNew />
                </Button>
            )}

            {permissions?.includes(ROLE_BIG_UPDATE_INTERVENTION_STATUS) && (
                <MultiSelectionButton
                    multiSelectionState={multiSelectionState}
                    setMultiSelectionState={setMultiSelectionState}
                />
            )}

            <RefreshButton
                data-cy='refresh-button'
                style={{
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}
            />

            <SelectColumnsButton />
        </TopToolbar>
    );
};

export default InterventionsListActions;
